const SideScroll = ({ componentNum, currentPage }) => {
  //개선안. handlebeforescroll을 이용하여 더 빠른 feedback은 없는지 확인해보기
  let pageArray = [];
  for (let i = 0; i < componentNum; i++) {
    if (i === currentPage) {
      pageArray.push(true);
    } else pageArray.push(false);
  }
  // console.log(pageArray);
  return (
    <ul
      className="d-none d-lg-block"
      style={{
        position: 'fixed',
        top: '50vh',
        zIndex: '99',
        listStyle: 'none',
      }}
    >
      {pageArray.map((element, key) => {
        if (element) return <li key={key}>🔵</li>;
        return <li key={key}>⚪</li>;
      })}
    </ul>
  );
};

export default SideScroll;
